import { MedicoesInput, ObjetivoInput } from 'graphql/types.generated'
import { parseNumber } from 'util/number'

import { ObjetivoFormModel } from './ObjetivoForm'

export const convertObjetivoFormToInput = (form: ObjetivoFormModel): ObjetivoInput =>
  form && {
    texto: form.texto,
    medicoes: convertMedicoesToInput(form),
    necessidadesEspeciais: form.necessidadesEspeciais,
  }

export const convertMedicoesToInput = (form: ObjetivoFormModel): MedicoesInput => {
  const { openedAccordions, ...rest } = form.medicoes
  return {
    dum: form.dum,
    vacinacaoEmDia: form.vacinacaoEmDia,
    altura: parseNumber(rest?.altura),
    circunferenciaAbdominal: parseNumber(rest?.circunferenciaAbdominal),
    frequenciaCardiaca: parseNumber(rest?.frequenciaCardiaca),
    frequenciaRespiratoria: parseNumber(rest?.frequenciaRespiratoria),
    perimetroCefalico: parseNumber(rest?.perimetroCefalico),
    perimetroPanturrilha: parseNumber(rest?.perimetroPanturrilha),
    peso: parseNumber(rest?.peso),
    pressaoArterialDiastolica: parseNumber(rest?.pressaoArterialDiastolica),
    pressaoArterialSistolica: parseNumber(rest?.pressaoArterialSistolica),
    saturacaoO2: parseNumber(rest?.saturacaoO2),
    glicemia: parseNumber(rest?.glicemia),
    temperatura: parseNumber(rest?.temperatura),
    tipoGlicemia: rest?.tipoGlicemia,
  }
}
